// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoPlayer_wrapper__N9rig"};